import { render, staticRenderFns } from "./goodsTag.vue?vue&type=template&id=5eb7c9e4&scoped=true&"
import script from "./goodsTag.vue?vue&type=script&lang=js&"
export * from "./goodsTag.vue?vue&type=script&lang=js&"
import style0 from "./goodsTag.vue?vue&type=style&index=0&id=5eb7c9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb7c9e4",
  null
  
)

export default component.exports